import { render, staticRenderFns } from "./default-view.vue?vue&type=template&id=d715d1e2&scoped=true"
import script from "./default-view.vue?vue&type=script&lang=ts"
export * from "./default-view.vue?vue&type=script&lang=ts"
import style0 from "./default-view.vue?vue&type=style&index=0&id=d715d1e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d715d1e2",
  null
  
)

export default component.exports